import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="loading" data-testid="loading" >
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default Loading;
